import { render } from "./LinkButtonField.vue?vue&type=template&id=ef461d6c"
import script from "./LinkButtonField.vue?vue&type=script&lang=js"
export * from "./LinkButtonField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__